/**
 * Truncates a string to a specified character limit and appends an ellipsis if truncated.
 */
export function truncateString(str: string, num: number) {
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + '...';
}
